var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Left'),_c('Map'),_c('Bottom'),_c('Right'),(_vm.showWarning)?_c('div',{staticClass:"dispatch-Warning-left"}):_vm._e(),(_vm.showWarning)?_c('div',{staticClass:"dispatch-Warning-right"}):_vm._e(),_c('SvgStationDispatch'),_c('SvgLineDispatch'),_c('StationProcess')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }